import { onLCP, onINP, onCLS } from "../../../utils/web-vitals";
import { sendAsyncMetric } from '.';
// import { InstanceType } from '../index'

export var startWebVitals = function startWebVitals(task) {
  startLCP(task);
  startINP(task);
  startCLS(task);
};
export var startLCP = function startLCP(task) {
  onLCP(function (metric) {
    console.log('[Measurements] Adding LCP', metric);
    // const entry = metric.entries.pop()
    // if (!entry) {
    //   return
    // }

    sendAsyncMetric(task, {
      type: 'lcp',
      value: parseInt(metric.value.toString()) || 0
    });
  });
};
export var startINP = function startINP(task) {
  onINP(function (metric) {
    console.log('[Measurements] Adding INP', metric);
    // const entry = metric.entries.pop()
    // if (!entry) {
    //   return
    // }

    sendAsyncMetric(task, {
      type: 'inp',
      value: parseInt(metric.value.toString()) || 0
    });
  });
};
export var startCLS = function startCLS(task) {
  onCLS(function (metric) {
    console.log('[Measurements] Adding CLS', metric);
    // const entry = metric.entries.pop()
    // if (!entry) {
    //   return
    // }

    sendAsyncMetric(task, {
      type: 'cls',
      value: parseInt(metric.value.toString()) || 0
    });
  });
};